////
/// ============================================================================
/// COMPONENT / LCP Target
/// ============================================================================
///
/// Forzo loading="eager" alle immagini above-de-fold caricate attraverso un
/// widget di Elementor con classe lcp-target
///
/// @group components
////

export default () => {
    const eagerImage = document.querySelector('.lcp-target img');
    if (eagerImage) {
        eagerImage.setAttribute('loading', 'eager');
    }
};
